module.exports = __webpack_public_path__ + "static/media/4.23.1ebeaaa0.png";